var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'bpb-etiqueta'+_vm.tipo_etiqueta},[_c('span',{staticClass:"bpb-etiqueta-text"},[_vm._v(_vm._s(_vm.text))]),_c('span',{staticClass:"bpb-etiqueta-circle"}),(_vm.close)?_c('span',{staticClass:"bpb-etiqueta-trash",on:{"click":_vm.cerrar}},[_c('i',{staticClass:"gg-close"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }